<template>
    <v-ons-page>
        <ons-toolbar>
            <div class="left"><ons-back-button></ons-back-button></div>
            <div class="center">Back to {{parentCollection.title}}</div>
        </ons-toolbar>
        <div class="qf-carousel">
            <v-ons-carousel  swipeable auto-scroll overscrollable auto-scroll-ratio="0.1" :index.sync="carouselIndex" class="">
                <v-ons-carousel-item v-for="item in carouselPhotos" v-bind:key="item.key">
                    <img class="carousel-image-bg" :src="item.path" :alt="item.title" style="width: 100%">
                    <img class="carousel-image" :src="item.path" :alt="item.title" style="width: 100%">
                </v-ons-carousel-item>
            </v-ons-carousel>
            <div class="dots">
              <span :index="dotIndex - 1" v-for="dotIndex in Object.keys(carouselPhotos).length" :key="dotIndex" style="cursor: pointer" @click="carouselIndex = dotIndex - 1">
                {{ carouselIndex === dotIndex - 1 ? '\u25CF' : '\u25CB' }}
              </span>
            </div>
        </div>

        <v-ons-list class="qf-label-data">
            <v-ons-list-header>Information</v-ons-list-header>
            <v-ons-list-item v-for="field in fields" :key="field.id">
                <div class="left">{{field.title}}</div>
                <div v-if="field.fieldType === 'url'" class="center">
                    <a :href="field.value[0]" target="_blank">{{field.value[0]}}</a>
                </div>
                <div v-else-if="field.fieldType === 'textarea'" class="center">
                    <div v-html="field.value[0]"></div>
                </div>
                <div v-else class="center">
                    <div v-for="(oneValue,key) in field.value" :key="key"> {{oneValue}}<span class="qf-value-separator" v-if="key !== (field.value.length - 1)">,  </span></div>
                </div>
            </v-ons-list-item>
        </v-ons-list>
        <v-ons-list v-if="documents.length > 0">
            <v-ons-list-header>Documents</v-ons-list-header>
            <v-ons-list-item v-for="document in documents" :key="document.id" @click="openAttachment(document)">
                <div class="left icon"><v-ons-icon icon="fa-file-pdf" class="list-item__icon"></v-ons-icon></div>
                <div class="center word-break">{{document.title}}</div>
            </v-ons-list-item>
        </v-ons-list>
    </v-ons-page>
</template>

<script>
    import SingleDocument from "../singleViews/SingleDocument";
    export default {
        name: "SingleCollection",
        data() {
            return {
                showFilter: false,
                carouselIndex: 0,
                photos: [
                    {
                        "title": "Shenzhen",
                        "imgSrc": "https://monaca.io/img/logos/download_image_onsenui_01.png",
                    }
                ],
            };
        },
        mounted : function() {
            console.log("Item data: ", this);
        },
        computed: {
          carouselPhotos() {
              let combinedPhotos = [];
              if(this.photos){
                  combinedPhotos = this.photos;
              }
              if(this.image){
                  let protoPhoto = {
                      path: this.image,
                      title: this.title
                  };
                  combinedPhotos.unshift(protoPhoto);
              }
              return combinedPhotos;
          }
        },
        methods: {
            openAttachment(attachment) {
                this.$store.commit('navigator/push', {
                    extends: SingleDocument,
                    data() {
                        return attachment;
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .qf-carousel{position: relative}
    .qf-carousel ons-carousel{height: 70vw !important; background: #1f1f21}
    .carousel-image{display: block; width: 100%;object-fit: contain;height: 100%; position: relative}
    img.carousel-image-bg {
        position: absolute;
        filter: blur(20px);
        top: -10%;
        right: -10%;
        bottom: -10%;
        left: -10%;
        width: 120% !important;
        height: 120% !important;
    }
    .dots {
        font-family: -apple-system,Helvetica Neue,Helvetica,Arial,Lucida Grande,sans-serif;
        text-align: center;
        font-size: 16px;
        color: #ffa101;
        bottom: 6px;
        position: absolute;
        left: 0;
        right: 0;
    }
    ons-carousel-item{overflow: hidden}
    .qf-value-separator {
        white-space: pre;
    }
</style>
